import { Component, OnInit } from '@angular/core';
import { FirebaseService } from './utils/firebase.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'emo20-dashboard-front';

  constructor(
    private firebase: FirebaseService,
  ) {
    
  }

  ngOnInit(){}

}
